import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { StagesSnapshotComponent } from './containers/stages-snapshot.component';

const routes: Routes = [{
  path: '',
  component: StagesSnapshotComponent,
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StagesSnapshotRoutingModule {
}
